import { render, staticRenderFns } from "./BiotimeAttendanceView.vue?vue&type=template&id=1310d660&scoped=true&"
import script from "./BiotimeAttendanceView.vue?vue&type=script&lang=js&"
export * from "./BiotimeAttendanceView.vue?vue&type=script&lang=js&"
import style0 from "./BiotimeAttendanceView.vue?vue&type=style&index=0&id=1310d660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310d660",
  null
  
)

export default component.exports